import "core-js/modules/es6.date.to-json";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.constructor";
import * as tslib_1 from "tslib";
import { dropUndefinedKeys, timestampWithMs, uuid4 } from '@sentry/utils';
import { SpanStatus } from './spanstatus';
export var TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
'([0-9a-f]{32})?' + // trace_id
'-?([0-9a-f]{16})?' + // span_id
'-?([01])?' + // sampled
'[ \\t]*$');
/**
 * Span contains all data about a span
 */

var Span =
/** @class */
function () {
  /**
   * You should never call the constructor manually, always use `hub.startSpan()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
  function Span(spanContext) {
    /**
     * @inheritDoc
     */
    this.traceId = uuid4();
    /**
     * @inheritDoc
     */

    this.spanId = uuid4().substring(16);
    /**
     * Timestamp in seconds when the span was created.
     */

    this.startTimestamp = timestampWithMs();
    /**
     * @inheritDoc
     */

    this.tags = {};
    /**
     * @inheritDoc
     */

    this.data = {};

    if (!spanContext) {
      return this;
    }

    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }

    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }

    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    } // We want to include booleans as well here


    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }

    if (spanContext.op) {
      this.op = spanContext.op;
    }

    if (spanContext.description) {
      this.description = spanContext.description;
    }

    if (spanContext.data) {
      this.data = spanContext.data;
    }

    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }

    if (spanContext.status) {
      this.status = spanContext.status;
    }

    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }

    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
  }
  /**
   * @inheritDoc
   * @deprecated
   */


  Span.prototype.child = function (spanContext) {
    return this.startChild(spanContext);
  };
  /**
   * @inheritDoc
   */


  Span.prototype.startChild = function (spanContext) {
    var span = new Span(tslib_1.__assign({}, spanContext, {
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId
    }));
    span.spanRecorder = this.spanRecorder;

    if (span.spanRecorder) {
      span.spanRecorder.add(span);
    }

    return span;
  };
  /**
   * Continues a trace from a string (usually the header).
   * @param traceparent Traceparent string
   */


  Span.fromTraceparent = function (traceparent, spanContext) {
    var matches = traceparent.match(TRACEPARENT_REGEXP);

    if (matches) {
      var sampled = void 0;

      if (matches[3] === '1') {
        sampled = true;
      } else if (matches[3] === '0') {
        sampled = false;
      }

      return new Span(tslib_1.__assign({}, spanContext, {
        parentSpanId: matches[2],
        sampled: sampled,
        traceId: matches[1]
      }));
    }

    return undefined;
  };
  /**
   * @inheritDoc
   */


  Span.prototype.setTag = function (key, value) {
    var _a;

    this.tags = tslib_1.__assign({}, this.tags, (_a = {}, _a[key] = value, _a));
    return this;
  };
  /**
   * @inheritDoc
   */


  Span.prototype.setData = function (key, value) {
    var _a;

    this.data = tslib_1.__assign({}, this.data, (_a = {}, _a[key] = value, _a));
    return this;
  };
  /**
   * @inheritDoc
   */


  Span.prototype.setStatus = function (value) {
    this.status = value;
    return this;
  };
  /**
   * @inheritDoc
   */


  Span.prototype.setHttpStatus = function (httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    var spanStatus = SpanStatus.fromHttpCode(httpStatus);

    if (spanStatus !== SpanStatus.UnknownError) {
      this.setStatus(spanStatus);
    }

    return this;
  };
  /**
   * @inheritDoc
   */


  Span.prototype.isSuccess = function () {
    return this.status === SpanStatus.Ok;
  };
  /**
   * @inheritDoc
   */


  Span.prototype.finish = function (endTimestamp) {
    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : timestampWithMs();
  };
  /**
   * @inheritDoc
   */


  Span.prototype.toTraceparent = function () {
    var sampledString = '';

    if (this.sampled !== undefined) {
      sampledString = this.sampled ? '-1' : '-0';
    }

    return this.traceId + "-" + this.spanId + sampledString;
  };
  /**
   * @inheritDoc
   */


  Span.prototype.getTraceContext = function () {
    return dropUndefinedKeys({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId
    });
  };
  /**
   * @inheritDoc
   */


  Span.prototype.toJSON = function () {
    return dropUndefinedKeys({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId
    });
  };

  return Span;
}();

export { Span };